import DOMPurify from "dompurify";
import { useEffect } from "react";
import { useState } from "react";

function RecruitmentDetailContent({ shareUrl }) {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!shareUrl) return;
    const fetchArticles = async () => {
      try {
        const response = await fetch(shareUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch article content");
        }
        const htmlContent = await response.text();

        const sanitizedContent = DOMPurify.sanitize(htmlContent);
        setContent(sanitizedContent);
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchArticles();
  }, [shareUrl]);
  return <div dangerouslySetInnerHTML={{ __html: content }} />;
}

export default RecruitmentDetailContent;
